import IntlMessages from "@richbeauty/utility/IntlMessages";
import { AppInputType } from "../../../../shared/constants/AppEnums";
import { useIntl } from "react-intl";
import {
  COMMON_FORM_ITEM_RULE,
  CUSTOMER_LEAD_STATUS,
} from "../../../../shared/constants/AppConst";
import useGetAllStates from "hooks/apis/state/useGetAllStates";

// @ts-ignore
const useCreateOrEditCustomerLeadFieldConfig = ({ isCreate }) => {
  const { messages } = useIntl();
  const { data } = useGetAllStates();

  return [
    {
      type: AppInputType.TEXT,
      inputConfig: { placeholder: messages["app.customerLeads.firstName"] },
      formItemConfig: {
        name: "firstName",
        label: <IntlMessages id="app.customerLeads.firstName" />,
        rules: [COMMON_FORM_ITEM_RULE.REQUIRED],
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: { placeholder: messages["app.customerLeads.lastName"] },
      formItemConfig: {
        name: "lastName",
        label: <IntlMessages id="app.customerLeads.lastName" />,
        rules: [COMMON_FORM_ITEM_RULE.REQUIRED],
      },
    },
    {
      type: AppInputType.PHONE_NUMBER_INPUT,
      inputConfig: { placeholder: messages["app.customerLeads.phone"] },
      formItemConfig: {
        name: "phoneNumber",
        label: <IntlMessages id="app.customerLeads.phone" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: { placeholder: messages["app.customerLeads.email"] },
      formItemConfig: {
        name: "email",
        label: <IntlMessages id="app.customerLeads.email" />,
        rules: [COMMON_FORM_ITEM_RULE.EMAIL],
      },
    },
    {
      type: AppInputType.DATE_PICKER,
      inputConfig: { placeholder: messages["app.customerLeads.dob"] },
      formItemConfig: {
        name: "dob",
        label: <IntlMessages id="app.customerLeads.dob" />,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        placeholder: messages["app.customerLeads.status"],
        options: CUSTOMER_LEAD_STATUS.map(({ value, label }) => ({
          value,
          label,
        })),
        defaultValue: isCreate ? CUSTOMER_LEAD_STATUS[0].value : undefined,
        hidden: isCreate,
        allowClear: false,
      },
      formItemConfig: {
        name: "status",
        label: <IntlMessages id="app.customerLeads.status" />,
        hidden: isCreate,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        placeholder: messages["app.customerLeads.gender"],
        options: [
          { value: 1, label: messages["app.customerLeads.gender.male"] },
          { value: 2, label: messages["app.customerLeads.gender.female"] },
          { value: 0, label: messages["app.customerLeads.gender.other"] },
        ],
      },
      formItemConfig: {
        name: "gender",
        label: <IntlMessages id="app.customerLeads.gender" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: { placeholder: messages["app.customerLeads.address"] },
      formItemConfig: {
        name: "address",
        label: <IntlMessages id="app.customerLeads.address" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.city"],
      },
      formItemConfig: {
        name: "city",
        label: <IntlMessages id="app.customerLeads.city" />,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        placeholder: messages["app.customerLeads.state"],
        options:
          data?.map((state) => ({
            value: state.id,
            label: `${state.name} (${state.code})`,
          })) || [],
      },
      formItemConfig: {
        name: "stateId",
        label: <IntlMessages id="app.customerLeads.state" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: { placeholder: messages["app.customerLeads.zipcode"] },
      formItemConfig: {
        name: "zipCode",
        label: <IntlMessages id="app.customerLeads.zipcode" />,
      },
    },
  ];
};

export default useCreateOrEditCustomerLeadFieldConfig;
